// @generated by protoc-gen-connect-query v1.4.2 with parameter "target=ts"
// @generated from file pharmacy.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Empty, MethodKind } from "@bufbuild/protobuf";
import { GenerateAuthTokenRequest, GenerateAuthTokenResponse } from "./auth/generate_auth_token_pb.js";
import { GetUserAccessRequest, GetUserAccessResponse } from "./auth/get_user_access_pb.js";
import { RefreshTokenRequest, RefreshTokenResponse } from "./auth/refresh_token_pb.js";
import { GetPharmacyInfoRequest, GetPharmacyInfoResponse } from "./auth/get_pharmacy_info_pb.js";
import { ChangeUserPasswordRequest, ChangeUserPasswordResponse, ForgotPasswordRequest, ForgotPasswordResponse, ResetPasswordRequest, ResetPasswordResponse } from "./auth/change_password_pb.js";
import { CreatePatientRequest, CreatePatientResponse } from "./patients/create_patient_pb.js";
import { UpdatePatientRequest, UpdatePatientResponse } from "./patients/update_patient_pb.js";
import { DeletePatientRequest, DeletePatientResponse } from "./patients/delete_patient_pb.js";
import { GetPatientRequest, GetPatientResponse } from "./patients/get_patient_pb.js";
import { ListPatientsRequest, ListPatientsResponse } from "./patients/list_patients_pb.js";
import { CreateDailyItemRequest, CreateDailyItemResponse } from "./dailyitems/create_daily_item_pb.js";
import { UpdateDailyItemRequest, UpdateDailyItemResponse } from "./dailyitems/update_daily_item_pb.js";
import { DeleteDailyItemRequest, DeleteDailyItemResponse } from "./dailyitems/delete_daily_item_pb.js";
import { GetTodayDailyItemRequest, GetTodayDailyItemResponse } from "./dailyitems/get_today_daily_item_pb.js";
import { ListAllDailyItemsRequest, ListAllDailyItemsResponse } from "./dailyitems/list_all_daily_items_pb.js";
import { MarkDailyItemRequest, MarkDailyItemResponse } from "./dailyitems/mark_daily_item_pb.js";
import { UnmarkDailyItemRequest, UnmarkDailyItemResponse } from "./dailyitems/unmark_daily_item_pb.js";
import { StartShiftRequest, StartShiftResponse } from "./shifts/start_shift_pb.js";
import { EndShiftRequest, EndShiftResponse } from "./shifts/end_shift_pb.js";
import { CurrentActiveShiftRequest, CurrentActiveShiftResponse } from "./shifts/current_active_shift_pb.js";
import { EndShiftSystemRequest, EndShiftSystemResponse } from "./shifts/end_shift_system_pb.js";
import { ListShiftsRequest, ListShiftsResponse } from "./shifts/list_shifts_pb.js";
import { ShiftSummaryRequest, ShiftSummaryResponse } from "./shifts/shift_summary_pb.js";
import { AddInventoryRequest, AddInventoryResponse } from "./inventory/add_inventory_pb.js";
import { CreateNonMedicalInventoryPriceRequest, CreateNonMedicalInventoryPriceResponse } from "./inventory/create_non_medical_inventory_price_pb.js";
import { GenerateCustomBarcodeRequest, GenerateCustomBarcodeResponse } from "./inventory/generate_custom_barcode_pb.js";
import { GetInventoryRequest, GetInventoryResponse } from "./inventory/get_inventory_pb.js";
import { GetNonMedicalInventoryPriceHistoryRequest, GetNonMedicalInventoryPriceHistoryResponse } from "./inventory/get_non_medical_inventory_price_history_pb.js";
import { InventoryOverviewRequest, InventoryOverviewResponse } from "./inventory/inventory_overview_pb.js";
import { UpdateInventoryMetadataRequest, UpdateInventoryMetadataResponse } from "./inventory/update_inventory_metadata_pb.js";
import { TransferInventoryRequestRequest, TransferInventoryRequestResponse } from "./inventory/transfer_inventory_request_pb.js";
import { PurchaseActivityRequest, PurchaseActivityResponse } from "./inventory/purchase_activity_pb.js";
import { TransferHistoryRequest, TransferHistoryResponse } from "./inventory/transfer_history_pb.js";
import { ChangeTransferStatusRequest, ChangeTransferStatusResponse } from "./inventory/change_transfer_status_pb.js";
import { StockMovementReportRequest, StockMovementReportResponse } from "./inventory/stock_movement_report_pb.js";
import { InventoryLedgerRequest, InventoryLedgerResponse } from "./inventory/inventory_ledger_pb.js";
import { InventoryStockPointSplitRequest, InventoryStockPointSplitResponse } from "./inventory/inventory_stock_point_split_pb.js";
import { InventoryBranchSplitRequest, InventoryBranchSplitResponse } from "./inventory/inventory_branch_split_pb.js";
import { GetMasterInventoryRequest, GetMasterInventoryResponse } from "./inventory/get_master_inventory_pb.js";
import { AcceptPricingAllRequest, AcceptPricingAllResponse } from "./medical_master/accept_pricing_all_pb.js";
import { AcceptPricingOneRequest, AcceptPricingOneResponse } from "./medical_master/accept_pricing_one_pb.js";
import { GetMedicalMasterRequest, GetMedicalMasterResponse } from "./medical_master/get_medical_master_pb.js";
import { ListMedicalMasterRequest, ListMedicalMasterResponse } from "./medical_master/list_medical_master_pb.js";
import { GetPriceHistoryRequest, GetPriceHistoryResponse } from "./medical_master/get_price_history_pb.js";
import { PricingPendingAcceptanceRequest, PricingPendingAcceptanceResponse } from "./medical_master/pricing_pending_acceptance_pb.js";
import { CreateNonMedicalMasterRequest, CreateNonMedicalMasterResponse } from "./non_medical_master/create_non_medical_master_pb.js";
import { ListNonMedicalMasterRequest, ListNonMedicalMasterResponse } from "./non_medical_master/list_non_medical_master_pb.js";
import { GetNonMedicalMasterRequest, GetNonMedicalMasterResponse } from "./non_medical_master/get_non_medical_master_pb.js";
import { CreatePurchaseInvoiceRequest, CreatePurchaseInvoiceResponse } from "./purchase_invoice/create_purchase_invoice_pb.js";
import { ListPurchaseInvoicesRequest, ListPurchaseInvoicesResponse } from "./purchase_invoice/list_purchase_invoices_pb.js";
import { GetPurchaseInvoiceRequest, GetPurchaseInvoiceResponse } from "./purchase_invoice/get_purchase_invoice_pb.js";
import { MakePaymentRequest, MakePaymentResponse } from "./purchase_invoice/make_payment_pb.js";
import { CreatePurchaseOrderRequest, CreatePurchaseOrderResponse } from "./purchase_order/create_purchase_order_pb.js";
import { ListPurchaseOrdersRequest, ListPurchaseOrdersResponse } from "./purchase_order/list_purchase_orders_pb.js";
import { GetPurchaseOrderRequest, GetPurchaseOrderResponse } from "./purchase_order/get_purchase_order_pb.js";
import { ListPurchaseRequestsRequest, ListPurchaseRequestsResponse } from "./purchase_request/list_purchase_requests_pb.js";
import { GetPurchaseRequestRequest, GetPurchaseRequestResponse } from "./purchase_request/get_purchase_request_pb.js";
import { SearchInventoryRequest, SearchInventoryResponse } from "./search/search_inventory_pb.js";
import { ListSuppliersRequest, ListSuppliersResponse } from "./suppliers/list_suppliers_pb.js";
import { CreateSupplierRequest, CreateSupplierResponse } from "./suppliers/create_supplier_pb.js";
import { GetSupplierRequest, GetSupplierResponse } from "./suppliers/get_supplier_pb.js";
import { CreateSaleRequest, CreateSaleResponse } from "./sales/create_sale_pb.js";
import { GetSaleRequest, GetSaleResponse } from "./sales/get_sale_pb.js";
import { ListSalesRequest, ListSalesResponse } from "./sales/list_sales_pb.js";
import { VoidSaleRequest, VoidSaleResponse } from "./sales/void_sale_pb.js";
import { RefundSaleRequest, RefundSaleResponse } from "./sales/refund_sale_pb.js";
import { DailySalesRequest, DailySalesResponse } from "./sales/daily_sales_pb.js";
import { OverviewReportRequest, OverviewReportResponse } from "./reports/overview_pb.js";
import { RevenueReportRequest, RevenueReportResponse } from "./reports/revenue_pb.js";
import { PLReportRequest, PLReportResponse } from "./reports/pl_report_pb.js";
import { SupplierProfitabilityReportRequest, SupplierProfitabilityReportResponse } from "./reports/supplier_profitability_report_pb.js";
import { ProductProfitabilityReportRequest, ProductProfitabilityReportResponse } from "./reports/product_profitability_report_pb.js";
import { CustomerProfitabilityReportRequest, CustomerProfitabilityReportResponse } from "./reports/customer_profitability_report_pb.js";
import { SalesPerItemReportRequest, SalesPerItemReportResponse } from "./reports/sales_per_item_report_pb.js";
import { SlowMovingItemsReportRequest, SlowMovingItemsReportResponse } from "./reports/slow_moving_items_report_pb.js";
import { FastMovingItemsReportRequest, FastMovingItemsReportResponse } from "./reports/fast_moving_items_report_pb.js";
import { ItemSalesVelocityReportRequest, ItemSalesVelocityReportResponse } from "./reports/item_sales_velocity_report_pb.js";
import { ItemsToReorderReportRequest, ItemsToReorderReportResponse } from "./reports/items_to_reorder_report_pb.js";
import { GetStockPointsRequest, GetStockPointsResponse } from "./branch/get_stock_points_pb.js";
import { CreateNewStockPointRequest, CreateNewStockPointResponse } from "./branch/create_new_stock_point_pb.js";
import { AccountsCogsRequest, AccountsCogsResponse } from "./accounts/accounts_cogs_pb.js";
import { AccountsRevenueRequest, AccountsRevenueResponse } from "./accounts/accounts_revenue_pb.js";
import { AccountsPLRequest, AccountsPLResponse } from "./accounts/accounts_pl_pb.js";
import { AccountsPaymentMethodBreakdownRequest, AccountsPaymentMethodBreakdownResponse } from "./accounts/accounts_payment_method_breakdown_pb.js";
import { CreatePurchaseReturnRequest, CreatePurchaseReturnResponse } from "./purchase_return/create_purchase_return_pb.js";
import { ListPurchaseReturnsRequest, ListPurchaseReturnsResponse } from "./purchase_return/list_purchase_returns_pb.js";
import { CompletePurchaseReturnRequest, CompletePurchaseReturnResponse } from "./purchase_return/complete_purchase_return_pb.js";
import { ListCreditNotesRequest, ListCreditNotesResponse } from "./purchase_return/list_credit_notes_pb.js";
import { MinMaxAutomationRequest, MinMaxAutomationResponse } from "./automations/min_max_pb.js";
import { UpdateMinMaxRequest, UpdateMinMaxResponse } from "./automations/update_min_max_pb.js";
import { CreateUserRequest, CreateUserResponse, GetUsersInPharmacyRequest, GetUsersInPharmacyResponse } from "./auth/users_pb.js";
import { SwitchContextRequest } from "./auth/switch_context_pb.js";
import { GetBranchesForCompanyRequest, GetBranchesForCompanyResponse } from "./branch/get_branches_pb.js";
import { GetMedicalInventoryStockRequest, GetMedicalInventoryStockResponse } from "./onboarding/get_medical_inventory_stock_pb.js";
import { GetNonMedicalInventoryStockRequest, GetNonMedicalInventoryStockResponse } from "./onboarding/get_non_medical_inventory_stock_pb.js";
import { TransferItemRequest, TransferItemResponse } from "./onboarding/transfer_item_pb.js";
import { UpsertMedicalInventoryRequest, UpsertMedicalInventoryResponse } from "./onboarding/upsert_medical_inventory_pb.js";
import { PharmacyRawDumpRequest } from "./dump/inventory_dump_pb.js";

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.Ping
 */
export const ping = {
  localName: "ping",
  name: "Ping",
  kind: MethodKind.Unary,
  I: Empty,
  O: Empty,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GenerateAuthToken
 */
export const generateAuthToken = {
  localName: "generateAuthToken",
  name: "GenerateAuthToken",
  kind: MethodKind.Unary,
  I: GenerateAuthTokenRequest,
  O: GenerateAuthTokenResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetUserAccess
 */
export const getUserAccess = {
  localName: "getUserAccess",
  name: "GetUserAccess",
  kind: MethodKind.Unary,
  I: GetUserAccessRequest,
  O: GetUserAccessResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.RefreshToken
 */
export const refreshToken = {
  localName: "refreshToken",
  name: "RefreshToken",
  kind: MethodKind.Unary,
  I: RefreshTokenRequest,
  O: RefreshTokenResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetPharmacyInfo
 */
export const getPharmacyInfo = {
  localName: "getPharmacyInfo",
  name: "GetPharmacyInfo",
  kind: MethodKind.Unary,
  I: GetPharmacyInfoRequest,
  O: GetPharmacyInfoResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ChangeUserPassword
 */
export const changeUserPassword = {
  localName: "changeUserPassword",
  name: "ChangeUserPassword",
  kind: MethodKind.Unary,
  I: ChangeUserPasswordRequest,
  O: ChangeUserPasswordResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ForgotPassword
 */
export const forgotPassword = {
  localName: "forgotPassword",
  name: "ForgotPassword",
  kind: MethodKind.Unary,
  I: ForgotPasswordRequest,
  O: ForgotPasswordResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ResetPassword
 */
export const resetPassword = {
  localName: "resetPassword",
  name: "ResetPassword",
  kind: MethodKind.Unary,
  I: ResetPasswordRequest,
  O: ResetPasswordResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CreatePatient
 */
export const createPatient = {
  localName: "createPatient",
  name: "CreatePatient",
  kind: MethodKind.Unary,
  I: CreatePatientRequest,
  O: CreatePatientResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.UpdatePatient
 */
export const updatePatient = {
  localName: "updatePatient",
  name: "UpdatePatient",
  kind: MethodKind.Unary,
  I: UpdatePatientRequest,
  O: UpdatePatientResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.DeletePatient
 */
export const deletePatient = {
  localName: "deletePatient",
  name: "DeletePatient",
  kind: MethodKind.Unary,
  I: DeletePatientRequest,
  O: DeletePatientResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetPatient
 */
export const getPatient = {
  localName: "getPatient",
  name: "GetPatient",
  kind: MethodKind.Unary,
  I: GetPatientRequest,
  O: GetPatientResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ListPatients
 */
export const listPatients = {
  localName: "listPatients",
  name: "ListPatients",
  kind: MethodKind.Unary,
  I: ListPatientsRequest,
  O: ListPatientsResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateDailyItem
 */
export const createDailyItem = {
  localName: "createDailyItem",
  name: "CreateDailyItem",
  kind: MethodKind.Unary,
  I: CreateDailyItemRequest,
  O: CreateDailyItemResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.UpdateDailyItem
 */
export const updateDailyItem = {
  localName: "updateDailyItem",
  name: "UpdateDailyItem",
  kind: MethodKind.Unary,
  I: UpdateDailyItemRequest,
  O: UpdateDailyItemResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.DeleteDailyItem
 */
export const deleteDailyItem = {
  localName: "deleteDailyItem",
  name: "DeleteDailyItem",
  kind: MethodKind.Unary,
  I: DeleteDailyItemRequest,
  O: DeleteDailyItemResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetTodayDailyItem
 */
export const getTodayDailyItem = {
  localName: "getTodayDailyItem",
  name: "GetTodayDailyItem",
  kind: MethodKind.Unary,
  I: GetTodayDailyItemRequest,
  O: GetTodayDailyItemResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ListAllDailyItems
 */
export const listAllDailyItems = {
  localName: "listAllDailyItems",
  name: "ListAllDailyItems",
  kind: MethodKind.Unary,
  I: ListAllDailyItemsRequest,
  O: ListAllDailyItemsResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.MarkDailyItem
 */
export const markDailyItem = {
  localName: "markDailyItem",
  name: "MarkDailyItem",
  kind: MethodKind.Unary,
  I: MarkDailyItemRequest,
  O: MarkDailyItemResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.UnmarkDailyItem
 */
export const unmarkDailyItem = {
  localName: "unmarkDailyItem",
  name: "UnmarkDailyItem",
  kind: MethodKind.Unary,
  I: UnmarkDailyItemRequest,
  O: UnmarkDailyItemResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.StartShift
 */
export const startShift = {
  localName: "startShift",
  name: "StartShift",
  kind: MethodKind.Unary,
  I: StartShiftRequest,
  O: StartShiftResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.EndShift
 */
export const endShift = {
  localName: "endShift",
  name: "EndShift",
  kind: MethodKind.Unary,
  I: EndShiftRequest,
  O: EndShiftResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CurrentActiveShift
 */
export const currentActiveShift = {
  localName: "currentActiveShift",
  name: "CurrentActiveShift",
  kind: MethodKind.Unary,
  I: CurrentActiveShiftRequest,
  O: CurrentActiveShiftResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.EndShiftSystem
 */
export const endShiftSystem = {
  localName: "endShiftSystem",
  name: "EndShiftSystem",
  kind: MethodKind.Unary,
  I: EndShiftSystemRequest,
  O: EndShiftSystemResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ListShifts
 */
export const listShifts = {
  localName: "listShifts",
  name: "ListShifts",
  kind: MethodKind.Unary,
  I: ListShiftsRequest,
  O: ListShiftsResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ShiftSummary
 */
export const shiftSummary = {
  localName: "shiftSummary",
  name: "ShiftSummary",
  kind: MethodKind.Unary,
  I: ShiftSummaryRequest,
  O: ShiftSummaryResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.AddInventory
 */
export const addInventory = {
  localName: "addInventory",
  name: "AddInventory",
  kind: MethodKind.Unary,
  I: AddInventoryRequest,
  O: AddInventoryResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateNonMedicalInventoryPrice
 */
export const createNonMedicalInventoryPrice = {
  localName: "createNonMedicalInventoryPrice",
  name: "CreateNonMedicalInventoryPrice",
  kind: MethodKind.Unary,
  I: CreateNonMedicalInventoryPriceRequest,
  O: CreateNonMedicalInventoryPriceResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GenerateCustomBarcode
 */
export const generateCustomBarcode = {
  localName: "generateCustomBarcode",
  name: "GenerateCustomBarcode",
  kind: MethodKind.Unary,
  I: GenerateCustomBarcodeRequest,
  O: GenerateCustomBarcodeResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetInventory
 */
export const getInventory = {
  localName: "getInventory",
  name: "GetInventory",
  kind: MethodKind.Unary,
  I: GetInventoryRequest,
  O: GetInventoryResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetNonMedicalInventoryPriceHistory
 */
export const getNonMedicalInventoryPriceHistory = {
  localName: "getNonMedicalInventoryPriceHistory",
  name: "GetNonMedicalInventoryPriceHistory",
  kind: MethodKind.Unary,
  I: GetNonMedicalInventoryPriceHistoryRequest,
  O: GetNonMedicalInventoryPriceHistoryResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.InventoryOverview
 */
export const inventoryOverview = {
  localName: "inventoryOverview",
  name: "InventoryOverview",
  kind: MethodKind.Unary,
  I: InventoryOverviewRequest,
  O: InventoryOverviewResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.UpdateInventoryMetadata
 */
export const updateInventoryMetadata = {
  localName: "updateInventoryMetadata",
  name: "UpdateInventoryMetadata",
  kind: MethodKind.Unary,
  I: UpdateInventoryMetadataRequest,
  O: UpdateInventoryMetadataResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.TransferInventoryRequest
 */
export const transferInventoryRequest = {
  localName: "transferInventoryRequest",
  name: "TransferInventoryRequest",
  kind: MethodKind.Unary,
  I: TransferInventoryRequestRequest,
  O: TransferInventoryRequestResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.PurchaseActivity
 */
export const purchaseActivity = {
  localName: "purchaseActivity",
  name: "PurchaseActivity",
  kind: MethodKind.Unary,
  I: PurchaseActivityRequest,
  O: PurchaseActivityResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.TransferHistory
 */
export const transferHistory = {
  localName: "transferHistory",
  name: "TransferHistory",
  kind: MethodKind.Unary,
  I: TransferHistoryRequest,
  O: TransferHistoryResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ChangeTransferStatus
 */
export const changeTransferStatus = {
  localName: "changeTransferStatus",
  name: "ChangeTransferStatus",
  kind: MethodKind.Unary,
  I: ChangeTransferStatusRequest,
  O: ChangeTransferStatusResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.StockMovementReport
 */
export const stockMovementReport = {
  localName: "stockMovementReport",
  name: "StockMovementReport",
  kind: MethodKind.Unary,
  I: StockMovementReportRequest,
  O: StockMovementReportResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.InventoryLedger
 */
export const inventoryLedger = {
  localName: "inventoryLedger",
  name: "InventoryLedger",
  kind: MethodKind.Unary,
  I: InventoryLedgerRequest,
  O: InventoryLedgerResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.InventoryStockPointSplit
 */
export const inventoryStockPointSplit = {
  localName: "inventoryStockPointSplit",
  name: "InventoryStockPointSplit",
  kind: MethodKind.Unary,
  I: InventoryStockPointSplitRequest,
  O: InventoryStockPointSplitResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.InventoryBranchSplit
 */
export const inventoryBranchSplit = {
  localName: "inventoryBranchSplit",
  name: "InventoryBranchSplit",
  kind: MethodKind.Unary,
  I: InventoryBranchSplitRequest,
  O: InventoryBranchSplitResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetMasterInventory
 */
export const getMasterInventory = {
  localName: "getMasterInventory",
  name: "GetMasterInventory",
  kind: MethodKind.Unary,
  I: GetMasterInventoryRequest,
  O: GetMasterInventoryResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.AcceptPricingAll
 */
export const acceptPricingAll = {
  localName: "acceptPricingAll",
  name: "AcceptPricingAll",
  kind: MethodKind.Unary,
  I: AcceptPricingAllRequest,
  O: AcceptPricingAllResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.AcceptPricingOne
 */
export const acceptPricingOne = {
  localName: "acceptPricingOne",
  name: "AcceptPricingOne",
  kind: MethodKind.Unary,
  I: AcceptPricingOneRequest,
  O: AcceptPricingOneResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetMedicalMaster
 */
export const getMedicalMaster = {
  localName: "getMedicalMaster",
  name: "GetMedicalMaster",
  kind: MethodKind.Unary,
  I: GetMedicalMasterRequest,
  O: GetMedicalMasterResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ListMedicalMaster
 */
export const listMedicalMaster = {
  localName: "listMedicalMaster",
  name: "ListMedicalMaster",
  kind: MethodKind.Unary,
  I: ListMedicalMasterRequest,
  O: ListMedicalMasterResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetPriceHistory
 */
export const getPriceHistory = {
  localName: "getPriceHistory",
  name: "GetPriceHistory",
  kind: MethodKind.Unary,
  I: GetPriceHistoryRequest,
  O: GetPriceHistoryResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.PricingPendingAcceptance
 */
export const pricingPendingAcceptance = {
  localName: "pricingPendingAcceptance",
  name: "PricingPendingAcceptance",
  kind: MethodKind.Unary,
  I: PricingPendingAcceptanceRequest,
  O: PricingPendingAcceptanceResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateNonMedicalMaster
 */
export const createNonMedicalMaster = {
  localName: "createNonMedicalMaster",
  name: "CreateNonMedicalMaster",
  kind: MethodKind.Unary,
  I: CreateNonMedicalMasterRequest,
  O: CreateNonMedicalMasterResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ListNonMedicalMaster
 */
export const listNonMedicalMaster = {
  localName: "listNonMedicalMaster",
  name: "ListNonMedicalMaster",
  kind: MethodKind.Unary,
  I: ListNonMedicalMasterRequest,
  O: ListNonMedicalMasterResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetNonMedicalMaster
 */
export const getNonMedicalMaster = {
  localName: "getNonMedicalMaster",
  name: "GetNonMedicalMaster",
  kind: MethodKind.Unary,
  I: GetNonMedicalMasterRequest,
  O: GetNonMedicalMasterResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CreatePurchaseInvoice
 */
export const createPurchaseInvoice = {
  localName: "createPurchaseInvoice",
  name: "CreatePurchaseInvoice",
  kind: MethodKind.Unary,
  I: CreatePurchaseInvoiceRequest,
  O: CreatePurchaseInvoiceResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ListPurchaseInvoices
 */
export const listPurchaseInvoices = {
  localName: "listPurchaseInvoices",
  name: "ListPurchaseInvoices",
  kind: MethodKind.Unary,
  I: ListPurchaseInvoicesRequest,
  O: ListPurchaseInvoicesResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetPurchaseInvoice
 */
export const getPurchaseInvoice = {
  localName: "getPurchaseInvoice",
  name: "GetPurchaseInvoice",
  kind: MethodKind.Unary,
  I: GetPurchaseInvoiceRequest,
  O: GetPurchaseInvoiceResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.MakePayment
 */
export const makePayment = {
  localName: "makePayment",
  name: "MakePayment",
  kind: MethodKind.Unary,
  I: MakePaymentRequest,
  O: MakePaymentResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CreatePurchaseOrder
 */
export const createPurchaseOrder = {
  localName: "createPurchaseOrder",
  name: "CreatePurchaseOrder",
  kind: MethodKind.Unary,
  I: CreatePurchaseOrderRequest,
  O: CreatePurchaseOrderResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ListPurchaseOrders
 */
export const listPurchaseOrders = {
  localName: "listPurchaseOrders",
  name: "ListPurchaseOrders",
  kind: MethodKind.Unary,
  I: ListPurchaseOrdersRequest,
  O: ListPurchaseOrdersResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetPurchaseOrder
 */
export const getPurchaseOrder = {
  localName: "getPurchaseOrder",
  name: "GetPurchaseOrder",
  kind: MethodKind.Unary,
  I: GetPurchaseOrderRequest,
  O: GetPurchaseOrderResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ListPurchaseRequests
 */
export const listPurchaseRequests = {
  localName: "listPurchaseRequests",
  name: "ListPurchaseRequests",
  kind: MethodKind.Unary,
  I: ListPurchaseRequestsRequest,
  O: ListPurchaseRequestsResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetPurchaseRequest
 */
export const getPurchaseRequest = {
  localName: "getPurchaseRequest",
  name: "GetPurchaseRequest",
  kind: MethodKind.Unary,
  I: GetPurchaseRequestRequest,
  O: GetPurchaseRequestResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.SearchInventory
 */
export const searchInventory = {
  localName: "searchInventory",
  name: "SearchInventory",
  kind: MethodKind.Unary,
  I: SearchInventoryRequest,
  O: SearchInventoryResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ListSuppliers
 */
export const listSuppliers = {
  localName: "listSuppliers",
  name: "ListSuppliers",
  kind: MethodKind.Unary,
  I: ListSuppliersRequest,
  O: ListSuppliersResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateSupplier
 */
export const createSupplier = {
  localName: "createSupplier",
  name: "CreateSupplier",
  kind: MethodKind.Unary,
  I: CreateSupplierRequest,
  O: CreateSupplierResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetSupplier
 */
export const getSupplier = {
  localName: "getSupplier",
  name: "GetSupplier",
  kind: MethodKind.Unary,
  I: GetSupplierRequest,
  O: GetSupplierResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateSale
 */
export const createSale = {
  localName: "createSale",
  name: "CreateSale",
  kind: MethodKind.Unary,
  I: CreateSaleRequest,
  O: CreateSaleResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetSale
 */
export const getSale = {
  localName: "getSale",
  name: "GetSale",
  kind: MethodKind.Unary,
  I: GetSaleRequest,
  O: GetSaleResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ListSales
 */
export const listSales = {
  localName: "listSales",
  name: "ListSales",
  kind: MethodKind.Unary,
  I: ListSalesRequest,
  O: ListSalesResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.VoidSale
 */
export const voidSale = {
  localName: "voidSale",
  name: "VoidSale",
  kind: MethodKind.Unary,
  I: VoidSaleRequest,
  O: VoidSaleResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.RefundSale
 */
export const refundSale = {
  localName: "refundSale",
  name: "RefundSale",
  kind: MethodKind.Unary,
  I: RefundSaleRequest,
  O: RefundSaleResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.DailySales
 */
export const dailySales = {
  localName: "dailySales",
  name: "DailySales",
  kind: MethodKind.Unary,
  I: DailySalesRequest,
  O: DailySalesResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.OverviewReport
 */
export const overviewReport = {
  localName: "overviewReport",
  name: "OverviewReport",
  kind: MethodKind.Unary,
  I: OverviewReportRequest,
  O: OverviewReportResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.RevenueReport
 */
export const revenueReport = {
  localName: "revenueReport",
  name: "RevenueReport",
  kind: MethodKind.Unary,
  I: RevenueReportRequest,
  O: RevenueReportResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.PLReport
 */
export const pLReport = {
  localName: "pLReport",
  name: "PLReport",
  kind: MethodKind.Unary,
  I: PLReportRequest,
  O: PLReportResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.SupplierProfitabilityReport
 */
export const supplierProfitabilityReport = {
  localName: "supplierProfitabilityReport",
  name: "SupplierProfitabilityReport",
  kind: MethodKind.Unary,
  I: SupplierProfitabilityReportRequest,
  O: SupplierProfitabilityReportResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ProductProfitabilityReport
 */
export const productProfitabilityReport = {
  localName: "productProfitabilityReport",
  name: "ProductProfitabilityReport",
  kind: MethodKind.Unary,
  I: ProductProfitabilityReportRequest,
  O: ProductProfitabilityReportResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CustomerProfitabilityReport
 */
export const customerProfitabilityReport = {
  localName: "customerProfitabilityReport",
  name: "CustomerProfitabilityReport",
  kind: MethodKind.Unary,
  I: CustomerProfitabilityReportRequest,
  O: CustomerProfitabilityReportResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.SalesPerItemReport
 */
export const salesPerItemReport = {
  localName: "salesPerItemReport",
  name: "SalesPerItemReport",
  kind: MethodKind.Unary,
  I: SalesPerItemReportRequest,
  O: SalesPerItemReportResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.SlowMovingItemsReport
 */
export const slowMovingItemsReport = {
  localName: "slowMovingItemsReport",
  name: "SlowMovingItemsReport",
  kind: MethodKind.Unary,
  I: SlowMovingItemsReportRequest,
  O: SlowMovingItemsReportResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.FastMovingItemsReport
 */
export const fastMovingItemsReport = {
  localName: "fastMovingItemsReport",
  name: "FastMovingItemsReport",
  kind: MethodKind.Unary,
  I: FastMovingItemsReportRequest,
  O: FastMovingItemsReportResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ItemSalesVelocityReport
 */
export const itemSalesVelocityReport = {
  localName: "itemSalesVelocityReport",
  name: "ItemSalesVelocityReport",
  kind: MethodKind.Unary,
  I: ItemSalesVelocityReportRequest,
  O: ItemSalesVelocityReportResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ItemsToReorderReport
 */
export const itemsToReorderReport = {
  localName: "itemsToReorderReport",
  name: "ItemsToReorderReport",
  kind: MethodKind.Unary,
  I: ItemsToReorderReportRequest,
  O: ItemsToReorderReportResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetStockPoints
 */
export const getStockPoints = {
  localName: "getStockPoints",
  name: "GetStockPoints",
  kind: MethodKind.Unary,
  I: GetStockPointsRequest,
  O: GetStockPointsResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateNewStockPoint
 */
export const createNewStockPoint = {
  localName: "createNewStockPoint",
  name: "CreateNewStockPoint",
  kind: MethodKind.Unary,
  I: CreateNewStockPointRequest,
  O: CreateNewStockPointResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.AccountsCogs
 */
export const accountsCogs = {
  localName: "accountsCogs",
  name: "AccountsCogs",
  kind: MethodKind.Unary,
  I: AccountsCogsRequest,
  O: AccountsCogsResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.AccountsRevenue
 */
export const accountsRevenue = {
  localName: "accountsRevenue",
  name: "AccountsRevenue",
  kind: MethodKind.Unary,
  I: AccountsRevenueRequest,
  O: AccountsRevenueResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.AccountsPL
 */
export const accountsPL = {
  localName: "accountsPL",
  name: "AccountsPL",
  kind: MethodKind.Unary,
  I: AccountsPLRequest,
  O: AccountsPLResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.AccountsPaymentMethodBreakdown
 */
export const accountsPaymentMethodBreakdown = {
  localName: "accountsPaymentMethodBreakdown",
  name: "AccountsPaymentMethodBreakdown",
  kind: MethodKind.Unary,
  I: AccountsPaymentMethodBreakdownRequest,
  O: AccountsPaymentMethodBreakdownResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CreatePurchaseReturn
 */
export const createPurchaseReturn = {
  localName: "createPurchaseReturn",
  name: "CreatePurchaseReturn",
  kind: MethodKind.Unary,
  I: CreatePurchaseReturnRequest,
  O: CreatePurchaseReturnResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ListPurchaseReturns
 */
export const listPurchaseReturns = {
  localName: "listPurchaseReturns",
  name: "ListPurchaseReturns",
  kind: MethodKind.Unary,
  I: ListPurchaseReturnsRequest,
  O: ListPurchaseReturnsResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CompletePurchaseReturn
 */
export const completePurchaseReturn = {
  localName: "completePurchaseReturn",
  name: "CompletePurchaseReturn",
  kind: MethodKind.Unary,
  I: CompletePurchaseReturnRequest,
  O: CompletePurchaseReturnResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.ListCreditNotes
 */
export const listCreditNotes = {
  localName: "listCreditNotes",
  name: "ListCreditNotes",
  kind: MethodKind.Unary,
  I: ListCreditNotesRequest,
  O: ListCreditNotesResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.MinMaxAutomation
 */
export const minMaxAutomation = {
  localName: "minMaxAutomation",
  name: "MinMaxAutomation",
  kind: MethodKind.Unary,
  I: MinMaxAutomationRequest,
  O: MinMaxAutomationResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.UpdateMinMax
 */
export const updateMinMax = {
  localName: "updateMinMax",
  name: "UpdateMinMax",
  kind: MethodKind.Unary,
  I: UpdateMinMaxRequest,
  O: UpdateMinMaxResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetUsersInPharmacy
 */
export const getUsersInPharmacy = {
  localName: "getUsersInPharmacy",
  name: "GetUsersInPharmacy",
  kind: MethodKind.Unary,
  I: GetUsersInPharmacyRequest,
  O: GetUsersInPharmacyResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.CreateUser
 */
export const createUser = {
  localName: "createUser",
  name: "CreateUser",
  kind: MethodKind.Unary,
  I: CreateUserRequest,
  O: CreateUserResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.SwitchPharmacyContext
 */
export const switchPharmacyContext = {
  localName: "switchPharmacyContext",
  name: "SwitchPharmacyContext",
  kind: MethodKind.Unary,
  I: SwitchContextRequest,
  O: GenerateAuthTokenResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetBranchesForCompany
 */
export const getBranchesForCompany = {
  localName: "getBranchesForCompany",
  name: "GetBranchesForCompany",
  kind: MethodKind.Unary,
  I: GetBranchesForCompanyRequest,
  O: GetBranchesForCompanyResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetMedicalInventoryStock
 */
export const getMedicalInventoryStock = {
  localName: "getMedicalInventoryStock",
  name: "GetMedicalInventoryStock",
  kind: MethodKind.Unary,
  I: GetMedicalInventoryStockRequest,
  O: GetMedicalInventoryStockResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.GetNonMedicalInventoryStock
 */
export const getNonMedicalInventoryStock = {
  localName: "getNonMedicalInventoryStock",
  name: "GetNonMedicalInventoryStock",
  kind: MethodKind.Unary,
  I: GetNonMedicalInventoryStockRequest,
  O: GetNonMedicalInventoryStockResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.TransferItem
 */
export const transferItem = {
  localName: "transferItem",
  name: "TransferItem",
  kind: MethodKind.Unary,
  I: TransferItemRequest,
  O: TransferItemResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.UpsertMedicalInventoryStock
 */
export const upsertMedicalInventoryStock = {
  localName: "upsertMedicalInventoryStock",
  name: "UpsertMedicalInventoryStock",
  kind: MethodKind.Unary,
  I: UpsertMedicalInventoryRequest,
  O: UpsertMedicalInventoryResponse,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;

/**
 * @generated from rpc com.neulink.pharmacy.PharmacyService.DumpPharmacyData
 */
export const dumpPharmacyData = {
  localName: "dumpPharmacyData",
  name: "DumpPharmacyData",
  kind: MethodKind.Unary,
  I: PharmacyRawDumpRequest,
  O: Empty,
  service: {
    typeName: "com.neulink.pharmacy.PharmacyService"
  }
} as const;
